import React from 'react'
import { Modal } from 'react-bootstrap'

const ShowImageModal = ({ show, onHide, header, imageSrc, altText }) => {
    return (<Modal show={show} onHide={() => onHide(null)} centered>
        <Modal.Header closeButton>
            <Modal.Title>{header}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
            <img
                src={imageSrc}
                alt={altText}
                style={{ width: '100%', height: 'auto', maxHeight: '70vh' }}
            />
        </Modal.Body>
    </Modal>)
}

export default ShowImageModal